import {isServer} from '@adv-mt/mt-utils'

import AdvertisingMappersFactory from '../Mappers/factory.js'
import AdvertisingRepositoriesFactory from '../Repositories/factory.js'
import DisplayAdsAdvertisingUseCase from './DisplayAdsAdvertisingUseCase.js'
import GetAdvertisingConfigurationUseCase from './GetAdvertisingConfigurationUseCase.js'
import GetPageDataAdvertisingUseCase from './GetPageDataAdvertisingUseCase.js'

export default class AdvertisingUseCasesFactory {
  static getAdvertisingConfigurationUseCase = ({config}) =>
    new GetAdvertisingConfigurationUseCase({
      repository: AdvertisingRepositoriesFactory.hTTPAdvertisingConfigurationRepository({
        config
      })
    })

  static displayAdsAdvertisingUseCase = ({config}) =>
    new DisplayAdsAdvertisingUseCase({
      config,
      fromRawDataToAdvertisingValueObjectMapper: AdvertisingMappersFactory.fromRawdataToAdvertisingValueObjectMapper({
        config
      }),
      repository: isServer
        ? AdvertisingRepositoriesFactory.emptyAdvertisingRepository({config})
        : AdvertisingRepositoriesFactory.domAdvertisingRepository({config})
    })

  static getPageDataAdvertisingUseCase = ({config}) =>
    new GetPageDataAdvertisingUseCase({
      config,
      fromRawDataToAdvertisingValueObjectMapper: AdvertisingMappersFactory.fromRawdataToAdvertisingValueObjectMapper({
        config
      })
    })
}
